export default __webpack_public_path__ + "static/media/Quit Smoking Pills.fbafa25f.png";